import path from 'path';

export const getAssetsDomain = () => {
  if (process.env.DISABLE_ASSETS_DOMAIN === 'true') {
    return ''
  }

  let assetsDomain = 'https://legacy.pluto.tv';

  if (process.env.FORCE_ASSETS_DOMAIN) {
    assetsDomain = process.env.FORCE_ASSETS_DOMAIN;
  }

  if (!assetsDomain.startsWith('https://')) {
    throw new Error('Invalid assets domain');
  }

  if (assetsDomain.endsWith('/')) {
    return assetsDomain.substr(0, assetsDomain.length - 1);
  }

  return assetsDomain;
}

export const ROOT = path.resolve(__dirname, '..', '..');
export const CLAPPR = path.join(ROOT, 'clappr/index.js');
export const CONFIG = path.join(ROOT, 'config');
export const CONFIG_WEBPACK = path.join(CONFIG, 'webpack');
export const STATIC_FILES_OUTPUT = path.join(ROOT, 'build', 'assets');
export const CLIENT_OUTPUT_ROOT = path.join(ROOT, 'build', 'client');
export const clientOutputRootFile = (file) => `${CLIENT_OUTPUT_ROOT}/${file}`;
export const CLIENT_OUTPUT = path.join(CLIENT_OUTPUT_ROOT, 'bundle');
export const CLIENT_STATS_OUTPUT = path.join(CLIENT_OUTPUT, 'stats.json');
export const CLIENT_SOURCE = path.join(ROOT, 'src');
export const CLIENT_ENTRY = path.join(CLIENT_SOURCE, 'index.js');
export const CLIENT_BASE_CONFIG = path.join(CONFIG_WEBPACK, 'client', 'base.js');
export const STATIC_FILES_SOURCE = path.join(CLIENT_SOURCE, 'assets');
export const STATIC_PUBLIC_PATH = `/assets/`;
export const SERVER_OUTPUT = path.join(ROOT, 'build', 'server');
export const SERVER_SOURCE = path.join(ROOT, 'server');
export const SERVER_ENTRY = path.join(SERVER_SOURCE, 'render.js');
export const SERVER_OUTPUT_ENTRY = path.join(SERVER_OUTPUT, 'main.js');
export const SERVER_BASE_CONFIG = path.join(CONFIG_WEBPACK, 'server', 'base.js');

export const AGE_DE_FILE_SOURCE = path.join(CLIENT_SOURCE, 'age-de.xml');
export const AGE_DE_FILE_OUTPUT = path.join(CLIENT_OUTPUT_ROOT, 'age-de.xml');
export const CONSENT_HTML_FILE_SOURCE = path.join(CLIENT_SOURCE, 'consent.html');
export const CONSENT_HTML_FILE_OUTPUT = path.join(CLIENT_OUTPUT_ROOT, 'consent.html');
export const ADS_TXT_FILE_SOURCE = path.join(CLIENT_SOURCE, 'ads.txt');
export const ADS_TXT_FILE_OUTPUT = path.join(CLIENT_OUTPUT_ROOT, 'ads.txt');
export const APP_ADS_TXT_FILE_OUTPUT = path.join(CLIENT_OUTPUT_ROOT, 'app-ads.txt');
export const STATIC_APPLE_APP_SITE_SOURCE = path.join(CLIENT_SOURCE, 'apple-app-site-association');
export const STATIC_APPLE_APP_SITE_OUTPUT = CLIENT_OUTPUT_ROOT;
